// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "trusted-by-module--base-text-alt--global--6068c";
export var baseTextGlobal = "trusted-by-module--base-text--global--5b19e";
export var blockSpacing100 = "trusted-by-module--block-spacing-100--82126";
export var blockSpacing50 = "trusted-by-module--block-spacing-50--db370";
export var blockVPadding100 = "trusted-by-module--block-v-padding-100--548a7";
export var blockVPadding50 = "trusted-by-module--block-v-padding-50--7ea7e";
export var captionTextGlobal = "trusted-by-module--caption-text--global--a7c2b";
export var cmsRenderedContentGlobal = "trusted-by-module--cms-rendered-content--global--cd5e3";
export var contentContainer = "trusted-by-module--contentContainer--a7c6c";
export var defaultHSpacingGlobal = "trusted-by-module--default-h-spacing--global--bb572";
export var fadeInAnimation = "trusted-by-module--fadeInAnimation--f1ffa";
export var fadeInOnLoadGlobal = "trusted-by-module--fade-in-on-load--global--80593";
export var fullHeightGlobal = "trusted-by-module--full-height--global--1d631";
export var fullHeightOmittingNavGlobal = "trusted-by-module--full-height-omitting-nav--global--0b024";
export var headingTextGlobal = "trusted-by-module--heading-text--global--d3f49";
export var ingressTextGlobal = "trusted-by-module--ingress-text--global--9aa6f";
export var linkColorChangeTransitionGlobal = "trusted-by-module--link-color-change-transition--global--06270";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "trusted-by-module--page-heading-text--global--453ca";
export var paragraphTextGlobal = "trusted-by-module--paragraph-text--global--e30b2";
export var partner = "trusted-by-module--partner--2f485";
export var partnerLogo = "trusted-by-module--partnerLogo--ce697";
export var partnersContainer = "trusted-by-module--partnersContainer--5369f";
export var subheadingTextGlobal = "trusted-by-module--subheading-text--global--714f0";
export var title = "trusted-by-module--title--a4848";